import { ACCOUNT_ROLE_CODES, AccountRoleCode } from './account-role';
import { SEX, Sex } from './sex';

export interface Account {
  cpf?: string;
  maskedCpf?: string | null;
  id: string;
  name: string;
  email: string;
  phone: string | null;
  profilePhotoUrl: string | null;
  sex?: Sex;
  birthDate: string;
  role: Exclude<AccountRoleCode, typeof ACCOUNT_ROLE_CODES.UNAUTH>;
  verifiedAt: string | null;
  forcePasswordChange?: boolean;
  createdAt: string;
  updatedAt: string;
  isStoreOwner: boolean;
}

export interface AdminAccount extends Account {
  deletedAt: string | null;
  blockedAt: string | null;
  lastLoginAt: string | null;
  lifecycleStatus: string;
}

export const accountRoleIs = (account: Account, role: AccountRoleCode) =>
  account.role === role;

export const accountIsAdmin = (account: Account) =>
  accountRoleIs(account, ACCOUNT_ROLE_CODES.ADMIN);

export const accountNeedsCPF = (account: Account | null | undefined) =>
  Boolean(account && !accountIsAdmin(account) && !account.maskedCpf);

export const accountIsClient = (account: Account) =>
  accountRoleIs(account, ACCOUNT_ROLE_CODES.CLIENT);

export const createEmptyAccount = (props: Partial<Account> = {}): Account => ({
  id: '',
  name: '',
  email: '',
  phone: null,
  profilePhotoUrl: null,
  sex: SEX.PREFER_TO_NOT_ANSWER,
  birthDate: '',
  role: ACCOUNT_ROLE_CODES.CLIENT,
  verifiedAt: null,
  forcePasswordChange: false,
  createdAt: '',
  updatedAt: '',
  isStoreOwner: false,
  ...props,
});

export const formatAccountName = (account: Account) => {
  if (!account.name) {
    return '';
  }

  const splittedName = account.name.split(' ');

  if (splittedName.length === 1) {
    return splittedName[0];
  }

  return `${splittedName[0]} ${splittedName[1]}`;
};
